import comp from "./ToolResponse";
export default comp;
